module.exports = __webpack_public_path__ + "static/media/sunglassbig.ee0fc446.jpg";